/* eslint-disable */
import React, { useState, useEffect } from "react";
import Input from "./Input";
import Popover from "./Popover";
import { Typography } from "@material-ui/core";
import cn from "classnames";
import { TimePickerView } from "@material-ui/pickers";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { useIntl, MessageDescriptor } from "react-intl";

import { usePickerStyles } from "./styles";

interface TimePickerControlProps {
  label: MessageDescriptor;
  value: string;
  onChange: (value: string) => void;
}
export const TimePickerControl: React.FC<TimePickerControlProps> = (props) => {
  const { value, onChange, label } = props;
  const classes = usePickerStyles();
  const [pickerDate, setPickerDate] = useState<Date>(new Date());
  const [pickerView, setPickerView] = useState<"hours" | "minutes">("hours");
  const { formatMessage } = useIntl();
  const [anchorEl, setAnchorEl] = React.useState(null);

  useEffect(() => {
    const d = new Date();
    const [hours, minutes] = value.split(":");

    d.setHours(+hours);
    d.setMinutes(+minutes || 0);
    setPickerDate(d);
  }, [value]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    applyPickerDate();
    setAnchorEl(null);
  };

  const applyPickerDate = () => {
    const hours = `0${pickerDate.getHours()}`.slice(-2);
    const minutes = `0${pickerDate.getMinutes()}`.slice(-2);
    const time = `${hours}:${minutes}:00`;
    if (time !== value) {
      onChange(time);
    }
  };

  const open = Boolean(anchorEl);
  const togglePopover = (e) => {
    setPickerView("hours");
    if (open) {
      handleClose();
    } else {
      handleClick(e);
    }
  };

  const hours = `0${pickerDate.getHours()}`.slice(-2);
  const minutes = `0${pickerDate.getMinutes()}`.slice(-2);

  return (
    <>
      <Input label={formatMessage(label)} value={`${hours}:${minutes}`} open={open} onClick={togglePopover} />
      <Popover anchorEl={anchorEl} onClose={togglePopover}>
        <div className={classes.time}>
          <Typography
            component="span"
            onClick={() => setPickerView("hours")}
            className={cn(classes.timePartition, { [classes.timePartitionActive]: pickerView === "hours" })}
          >
            {hours}
          </Typography>
          :
          <Typography
            component="span"
            onClick={() => setPickerView("minutes")}
            className={cn(classes.timePartition, { [classes.timePartitionActive]: pickerView === "minutes" })}
          >
            {minutes}
          </Typography>
        </div>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <TimePickerView
            type={pickerView}
            date={pickerDate}
            onHourChange={(date) => {
              if (date) {
                setPickerDate(date);
              }
            }}
            onMinutesChange={(date) => {
              if (date) {
                setPickerDate(date);
              }
            }}
            onSecondsChange={() => {}}
            ampm={false}
          />
        </MuiPickersUtilsProvider>
      </Popover>
    </>
  );
};
